// Import and register all Stimulus controllers

import { application } from "./application"

// Import all controllers
import AddressAutocompleteController from "./address_autocomplete_controller"
import DynamicFormController from "./dynamic_form_controller"
import FormToggleController from "./form_toggle_controller"
import FormValidationController from "./form_validation_controller"
import LocationDisplayController from "./location_display_controller"
import MapLocationPickerController from "./map_location_picker_controller"
import RegionSelectorController from "./region_selector_controller"
import UrlFieldController from "./url_field_controller"

// Register controllers with Stimulus
application.register("address-autocomplete", AddressAutocompleteController)
application.register("dynamic-form", DynamicFormController)
application.register("form-toggle", FormToggleController)
application.register("form-validation", FormValidationController)
application.register("location-display", LocationDisplayController)
application.register("map-location-picker", MapLocationPickerController)
application.register("region-selector", RegionSelectorController)
application.register("url-field", UrlFieldController)